import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "max-w-4xl mx-auto" }
const _hoisted_2 = { class: "text-center py-24 w-60 max-w-60 mx-auto" }
const _hoisted_3 = { class: "text-left text-xs text-white pt-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-80 bg-purple-600 text-white px-1 py-p1 mr-1 rounded-sm" }, "Tip:", -1 /* HOISTED */)
const _hoisted_5 = { class: "opacity-50" }
const _hoisted_6 = { class: "space-y-8 divide-y divide-gray-700 pb-32 px-4 lg:px-0" }
const _hoisted_7 = { class: "space-y-8 divide-y divide-gray-700 sm:space-y-5" }
const _hoisted_8 = { class: "space-y-6 sm:space-y-5" }
const _hoisted_9 = { class: "text-md font-medium leading-6 pb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "px-2 text-gray-600" }, "/", -1 /* HOISTED */)
const _hoisted_11 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-700 sm:pt-5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "sceneName",
  class: "block text-sm font-medium text-gray-300 sm:mt-px sm:pt-2"
}, "Change Scene Name", -1 /* HOISTED */)
const _hoisted_13 = { class: "mt-1 sm:col-span-2 sm:mt-0" }
const _hoisted_14 = { class: "flex rounded-md shadow-sm" }
const _hoisted_15 = { class: "text-xs py-4 text-gray-400" }
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = { class: "space-y-1 py-1" }
const _hoisted_18 = { class: "bg-black px-1 py-px" }
const _hoisted_19 = { class: "bg-black px-1 py-px" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "bg-black px-1 py-px" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "space-y-2 sm:space-y-2" }
const _hoisted_24 = { class: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:border-t sm:border-gray-700 sm:pt-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "sceneName",
  class: "block text-sm font-medium text-gray-300 sm:mt-px sm:pt-2"
}, "Delete Scene", -1 /* HOISTED */)
const _hoisted_26 = { class: "mt-1 sm:col-span-2 sm:mt-0" }
const _hoisted_27 = { class: "flex justify-start text-xs pb-4 text-gray-400" }
const _hoisted_28 = { class: "max-w-xl text-left" }
const _hoisted_29 = { class: "space-y-1 py-1" }
const _hoisted_30 = { class: "bg-black px-1 py-px" }
const _hoisted_31 = { class: "bg-black px-1 py-px" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-400 font-bold" }, "This cannot be undone.", -1 /* HOISTED */)
const _hoisted_33 = { class: "flex justify-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SceneCard = _resolveComponent("SceneCard")!
  const _component_CameraIcon = _resolveComponent("CameraIcon")!
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ArrowPathIcon = _resolveComponent("ArrowPathIcon")!
  const _component_XMarkIcon = _resolveComponent("XMarkIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SceneCard, {
        sceneName: _ctx.sceneName,
        displayBottomBar: false
      }, null, 8 /* PROPS */, ["sceneName"]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, [
          _createTextVNode("Update the loading poster by clicking on the camera icon "),
          _createVNode(_component_CameraIcon, { class: "inline w-4" }),
          _createTextVNode(", above the 3D viewer.")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h3", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: _ctx.Route.ROOT,
              class: "inline-block text-white text-emerald-400 hover:text-emerald-200"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ChevronLeftIcon, { class: "inline h-4 ml-1" }),
                _createTextVNode(" Dashboard ")
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"]),
            _hoisted_10,
            _createVNode(_component_router_link, {
              to: _ctx.backToScenePath,
              class: "inline-block text-emerald-400 hover:text-emerald-200"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.sceneName), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"])
          ]),
          _createElementVNode("form", {
            class: "space-y-2 sm:space-y-2",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateSceneName && _ctx.updateSceneName(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.updatedSceneName) = $event)),
                    class: "block w-full min-w-0 flex-1 rounded-md border-0 sm:text-sm bg-black text-white",
                    onKeypress: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                    onKeyup: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                    onKeydown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelText, _ctx.updatedSceneName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createTextVNode(" The scene files are saved in the folders: "),
                    _createElementVNode("ul", _hoisted_17, [
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.srcFolder), 1 /* TEXT */)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.publicFolder), 1 /* TEXT */)
                      ])
                    ]),
                    _createTextVNode(" Updating the scene name will rename those folders to "),
                    (_ctx.updatedSceneAllowed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.updatedSceneName), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_22, "the new scene name."))
                  ])
                ]),
                _createElementVNode("div", null, [
                  (_ctx.loadingUpdateName)
                    ? (_openBlock(), _createBlock(_component_ArrowPathIcon, {
                        key: 0,
                        class: "animate-spin inline pointer-events-none h-5 w-5 text-gray-400"
                      }))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass([
											'inline-flex justify-center rounded-sm  py-2 px-4 text-sm font-medium text-white shadow-sm ',
											_ctx.updatedSceneAllowed
												? 'bg-green-600 hover:bg-green-700 cursor-pointer'
												: 'bg-gray-400',
										]),
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateSceneName && _ctx.updateSceneName(...args)))
                      }, " Update Scene Name ", 2 /* CLASS */))
                ])
              ])
            ])
          ], 32 /* HYDRATE_EVENTS */),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createTextVNode(" Deleting the scene files will remove the folders: "),
                    _createElementVNode("ul", _hoisted_29, [
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.srcFolder), 1 /* TEXT */)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.publicFolder), 1 /* TEXT */)
                      ])
                    ]),
                    _hoisted_32
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  (_ctx.loadingDelete)
                    ? (_openBlock(), _createBlock(_component_ArrowPathIcon, {
                        key: 0,
                        class: "animate-spin inline pointer-events-none h-5 w-5 text-gray-400"
                      }))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "inline-flex justify-center rounded-sm py-2 px-4 text-sm font-medium text-white shadow-sm bg-red-600 hover:bg-red-700 cursor-pointer",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.deleteScene && _ctx.deleteScene(...args)))
                      }, [
                        _createVNode(_component_XMarkIcon, {
                          class: "-ml-1 mr-2 h-5 w-5",
                          "aria-hidden": "true"
                        }),
                        _createTextVNode(" Delete Scene ")
                      ]))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}